import { combineReducers } from 'redux-immutable'
import { Map } from 'immutable'

import {
  activityActions,
  getIdentityProgress,
  postAuthEmail,
  postAuthPhone,
  updateActivity,
} from 'store/entities/identity/actions'
import * as types from './actionTypes'
import * as LOGIN_ERRORS from 'app/constants/loginErrors'
import { clearLoginError } from './actions'

export function mobileNavReducer(state = false, action) {
  const { type } = action

  switch (type) {
    case types.UI_OPEN_MOBILE_NAV:
      return true
    case types.UI_CLOSE_MOBILE_NAV:
      return false
    default:
      return state
  }
}

export const loginState = Map({
  loginError: Map({
    phone: null,
    email: null,
  }),
  submitting: null,
  queries: Map(),
})

export function loginReducer(state = loginState, action) {
  const { type, payload } = action
  switch (type) {
    case postAuthPhone.fail.toString(): {
      if (!window.navigator.onLine) {
        return state.setIn(['loginError', 'phone'], LOGIN_ERRORS.NO_INTERNET_CONNECTION).set('submitting', false)
      }
      if (payload && payload.statusCode === 403) {
        return state.setIn(['loginError', 'phone'], LOGIN_ERRORS.ORGANIZATION_DISABLED).set('submitting', false)
      } else {
        return state.setIn(['loginError', 'phone'], LOGIN_ERRORS.PHONE_NOT_FOUND).set('submitting', false)
      }
    }
    case postAuthEmail.fail.toString(): {
      if (!window.navigator.onLine) {
        return state.setIn(['loginError', 'email'], LOGIN_ERRORS.NO_INTERNET_CONNECTION).set('submitting', false)
      }
      if (payload && payload.statusCode === 403) {
        return state.setIn(['loginError', 'email'], LOGIN_ERRORS.ORGANIZATION_DISABLED).set('submitting', false)
      } else {
        return state.setIn(['loginError', 'email'], LOGIN_ERRORS.NO_USER_FOUND_WITH_THIS_EMAIL).set('submitting', false)
      }
    }
    case postAuthPhone.success.toString():
    case postAuthEmail.success.toString(): {
      return state.set('loginError', Map({ email: null, phone: null })).set('submitting', false)
    }
    case postAuthPhone.toString(): {
      const {
        request: {
          data: { phone },
        },
      } = payload
      return state.set('submitting', true).set('queries', Map({ phone }))
    }
    case postAuthEmail.toString(): {
      return state.set('submitting', true)
    }
    case clearLoginError.toString(): {
      return state.set('loginError', Map({ email: null, phone: null }))
    }
    default:
      return state
  }
}

export const forceLeaveReducer = (state = false, action) => {
  const { type } = action
  switch (type) {
    case types.UI_ENABLE_FORCE_LEAVE: {
      return true
    }
    case types.UI_DISABLE_FORCE_LEAVE: {
      return false
    }
    default:
      return state
  }
}

export const activityScreen = Map({
  show: true,
  activityActionButtonsDisabled: false,
})

export const activityScreenReducer = (state = activityScreen, action) => {
  const { type, payload } = action
  switch (type) {
    case types.UI_DISABLE_ACTIVITY_ACTIONS_BUTTONS: {
      return state.set('activityActionButtonsDisabled', payload.disabled)
    }
    // TODO: check variable from identity entity instead
    case activityActions.commit.toString():
    case activityActions.did.toString():
    case activityActions.didnot.toString():
    case activityActions.complete.toString():
    case updateActivity.toString():
    case getIdentityProgress.toString(): {
      return state.set('activityActionButtonsDisabled', true)
    }
    // TODO: check variable from identity entity instead
    case activityActions.commit.fail.toString():
    case activityActions.did.fail.toString():
    case activityActions.didnot.fail.toString():
    case activityActions.complete.fail.toString():
    case updateActivity.fail.toString():
    case getIdentityProgress.fail.toString(): {
      return state.set('activityActionButtonsDisabled', false)
    }
    // TODO: remove and use selector from identity instead
    case activityActions.commit.success.toString():
    case activityActions.did.success.toString():
    case activityActions.didnot.success.toString():
    case activityActions.complete.success.toString():
    case updateActivity.success.toString():
    case getIdentityProgress.success.toString(): {
      return state.set('activityActionButtonsDisabled', false)
    }
    default:
      return state
  }
}

export const windowSizesInitialState = Map({
  width: 0,
  height: 0,
})

export const windowSizesReducer = (state = windowSizesInitialState, action) => {
  const { type, payload } = action
  switch (type) {
    case types.UI_CHANGE_WINDOW_SIZES: {
      return state.set('width', payload.width).set('height', payload.height)
    }
  }
  return state
}

export default combineReducers({
  mobileNav: mobileNavReducer,
  login: loginReducer,
  forceLeave: forceLeaveReducer,
  activityScreen: activityScreenReducer,
  windowSizes: windowSizesReducer,
})
